import React from "react";
import { Link } from "react-router-dom";
import {
  FaAward,
  FaUsers,
  FaCog,
  FaShieldAlt,
  FaCheck,
  FaArrowRight,
} from "react-icons/fa";

const brandImages = [1, 2, 3, 4, 5, 6];

const indiaCities = [
  "Delhi",
  "Kolkata",
  "Mumbai",
  "Hyderabad",
  "Bangalore",
  "Chennai",
];

const About = () => {
  return (
    <>
      {/* ── Page Hero ── */}
      <section className="relative h-[480px] overflow-hidden">
        <img
          src="/images/banner.png"
          alt="About Us"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/55" />
        <div className="absolute inset-0 flex items-center z-10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 w-full">
            <span className="inline-block bg-blue-700 px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-widest text-white mb-5">
              Om Maruticreation
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
              About Us
            </h1>
          </div>
        </div>
      </section>

      {/* ── Our Story ── */}
      <section className="py-20 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 grid lg:grid-cols-2 gap-16 items-center">
          {/* Left */}
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-blue-600">
              Our Story
            </span>
            <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
              OM Maruthi Creations
            </h2>
            <div className="flex items-center gap-4 mt-6">
              <div className="h-px flex-1 bg-gray-200" />
              <span className="text-sm font-bold text-blue-700 tracking-widest uppercase whitespace-nowrap">
                SINCE 2006
              </span>
              <div className="h-px flex-1 bg-gray-200" />
            </div>
            <p className="mt-6 text-gray-600 text-lg leading-relaxed">
              OM Maruthi Creations is a leading men garment manufacturing
              company established in 2006 with a strong reputation for quality,
              innovation, and reliable production. Located in Peenya 2nd Stage,
              Bangalore, we specialize in premium men's apparel manufacturing
              including formal wear, casual wear, uniforms, and customized
              garment solutions.
            </p>
            <div className="mt-10 flex items-center gap-6 bg-blue-50 rounded-2xl p-6">
              <div className="bg-blue-700 h-16 w-16 rounded-full flex items-center justify-center text-white text-2xl shadow-lg flex-shrink-0">
                <FaUsers />
              </div>
              <div>
                <h4 className="text-2xl font-bold text-gray-900">
                  1,500 – 1,800
                </h4>
                <p className="text-gray-600 mt-1">Total Factory Labours</p>
              </div>
            </div>
          </div>

          {/* Right */}
          <div className="rounded-3xl overflow-hidden h-[520px]">
            <img
              src="/images/about.png"
              alt="About OM Maruthi Creations"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      {/* ── Stats Bar ── */}
      <section className="bg-blue-700 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 text-center text-white">
            {[
              { number: "20+", label: "Years Experience" },
              { number: "1500+", label: "Skilled Workforce" },
              { number: "500+", label: "Happy Clients" },
              { number: "100K+", label: "Garments Produced" },
            ].map((stat, i) => (
              <div key={i}>
                <p className="text-4xl md:text-5xl font-bold">{stat.number}</p>
                <p className="text-blue-200 mt-2 font-medium">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Brand Partners ── */}
      <section className="py-20 lg:py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-14">
            <span className="text-xs font-semibold uppercase tracking-widest text-blue-600">
              Trusted By
            </span>
            <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900">
              Our Product Brands
            </h2>
            <p className="mt-4 text-gray-500 text-lg max-w-2xl mx-auto">
              OM Maruthi Creations proudly manufactures and supplies garments
              for more than 12 trusted fashion and clothing brands across India.
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-5">
            {brandImages.map((num) => (
              <div
                key={num}
                className="bg-white p-4 rounded-xl border border-gray-100 hover:border-blue-200 transition flex items-center justify-center"
              >
                <img
                  src={`/images/brands/${num}.png`}
                  alt={`Brand ${num}`}
                  className="w-full h-[80px] object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Global Supply ── */}
      <section className="py-20 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-14">
            <span className="text-xs font-semibold uppercase tracking-widest text-blue-600">
              Global Reach
            </span>
            <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900">
              Export &amp; Import Supplier
            </h2>
            <p className="mt-4 text-gray-500 text-lg max-w-2xl mx-auto">
              Supplying premium garments across India and international markets
              including Canada, Malaysia, and China.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            {/* Canada */}
            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-lg transition-shadow duration-300 overflow-hidden group hover:-translate-y-1">
              <div className="h-56 overflow-hidden">
                <img
                  src="/images/canada.png"
                  className="w-full h-full object-cover group-hover:scale-105 transition duration-500"
                  alt="Canada"
                />
              </div>
              <div className="p-6 text-center">
                <h3 className="text-2xl font-bold text-blue-700">Canada</h3>
                <p className="text-gray-500 mt-2 text-sm">
                  Premium garment export supply with trusted logistics and
                  delivery.
                </p>
              </div>
            </div>

            {/* Malaysia */}
            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-lg transition-shadow duration-300 overflow-hidden group hover:-translate-y-1">
              <div className="h-56 overflow-hidden">
                <img
                  src="https://images.unsplash.com/photo-1596422846543-75c6fc197f07?q=80&w=1200&auto=format&fit=crop"
                  className="w-full h-full object-cover group-hover:scale-105 transition duration-500"
                  alt="Malaysia"
                />
              </div>
              <div className="p-6 text-center">
                <h3 className="text-2xl font-bold text-blue-700">Malaysia</h3>
                <p className="text-gray-500 mt-2 text-sm">
                  High-quality apparel manufacturing and international supply
                  solutions.
                </p>
              </div>
            </div>

            {/* China */}
            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-lg transition-shadow duration-300 overflow-hidden group hover:-translate-y-1">
              <div className="h-56 overflow-hidden">
                <img
                  src="https://images.unsplash.com/photo-1508804185872-d7badad00f7d?q=80&w=1200&auto=format&fit=crop"
                  className="w-full h-full object-cover group-hover:scale-105 transition duration-500"
                  alt="China"
                />
              </div>
              <div className="p-6 text-center">
                <h3 className="text-2xl font-bold text-blue-700">China</h3>
                <p className="text-gray-500 mt-2 text-sm">
                  Global export and import support for fashion and garment
                  industries.
                </p>
              </div>
            </div>
          </div>

          {/* India Cities */}
          <div className="bg-blue-700 rounded-2xl p-10 text-white">
            <div className="text-center mb-10">
              <h3 className="text-3xl font-bold">Supply Across India</h3>
              <p className="text-blue-200 mt-3">
                Serving major cities with reliable garment manufacturing and
                distribution.
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 text-center">
              {indiaCities.map((city) => (
                <div
                  key={city}
                  className="bg-white/10 rounded-xl py-4 px-3 backdrop-blur-sm hover:bg-white/20 transition"
                >
                  <p className="text-lg font-semibold">{city}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="py-20 lg:py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-12 text-center max-w-3xl mx-auto">
            <span className="text-xs font-semibold uppercase tracking-widest text-blue-600">
              Ready to Work With Us?
            </span>
            <h2 className="mt-4 text-3xl md:text-4xl font-bold text-gray-900">
              Start Your Garment Manufacturing Journey
            </h2>
            <p className="mt-4 text-gray-500 text-lg">
              Partner with OM Maruthi Creations for premium quality, bulk
              orders, and reliable delivery.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 bg-blue-700 hover:bg-blue-800 text-white font-semibold px-6 py-3 rounded-full transition-all duration-200 shadow-sm hover:shadow-md"
              >
                Get Quote <FaArrowRight className="text-sm" />
              </Link>
              <Link
                to="/products"
                className="inline-flex items-center justify-center gap-2 border-2 border-blue-700 text-blue-700 hover:bg-blue-700 hover:text-white font-semibold px-6 py-3 rounded-full transition-all duration-200"
              >
                View Products
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
